import * as Yup from 'yup';

const Validation = Yup.object({
    points: Yup.number().required("Points is Required"),
});

export default Validation;
